const round1entries = {
  // Natural speech
  natural_speech_1: {
    tag: "natural_speech",
    label: "natural_speech_1",
    description: "He used hard candy to replace his smoking habit.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-natural_speech_1.wav",
    winner: "natural_speech_1_aaa864a9-b237-4568-940c-4e2a6c504ff0.wav",
    original: "original_wavs/Speech_1.wav"
  },
  natural_speech_2: {
    tag: "natural_speech",
    label: "natural_speech_2",
    description: "Success should be measured by stability, not stuff.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-natural_speech_2.wav",
    winner: "natural_speech_2_04b17f7a-1696-414e-8835-5606a2325e79.wav",
    original: "original_wavs/Speech_2.wav"
  },
  natural_speech_3: {
    tag: "natural_speech",
    label: "natural_speech_3",
    description: "You say ‘idiot’ like it’s a bad thing.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-natural_speech_3.wav",
    winner: "natural_speech_3_267de966-2c5b-4941-b306-04f00f43a843.wav",
    original: "original_wavs/Speech_3.wav"
  },
  natural_speech_4: {
    tag: "natural_speech",
    label: "natural_speech_4",
    description: "He could not balance a relationship with his friendship.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-natural_speech_4.wav",
    winner: "natural_speech_4_e91f2a0c-bee4-4eff-98ae-f176e3f18f40.wav",
    original: "original_wavs/Speech_4.wav"
  },
  natural_speech_5: {
    tag: "natural_speech",
    label: "natural_speech_5",
    description: "She realized her mistake after the fact.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-natural_speech_5.wav",
    winner: "natural_speech_5_583619fe-cbee-405a-9347-6508791fc21e.wav",
    original: "original_wavs/Speech_5.wav"
  },
  natural_speech_6: {
    tag: "natural_speech",
    label: "natural_speech_6",
    description: "His dirty fingernails left a bad impression.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-natural_speech_6.wav",
    winner: "natural_speech_6_041567a8-c976-4282-9530-b597dadbfda4.wav",
    original: "original_wavs/Speech_6.wav"
  },
  // CNC words
  cnc_1: {
    tag: "cnc",
    label: "cnc_1",
    description: "Gore - met - jerk",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-cnc_1.wav",
    winner: "cnc_1_852ec6c6-56fe-4760-a397-b137afc7bdc6.wav",
    original: "original_wavs/CNC_1.wav"
  },
  cnc_2: {
    tag: "cnc",
    label: "cnc_2",
    description: "Leave - rag - fit",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-cnc_2.wav",
    winner: "cnc_2_db3ae40a-8878-4f8a-b0cf-a2f6237eb48f.wav",
    original: "original_wavs/CNC_2.wav"
  },
  cnc_3: {
    tag: "cnc",
    label: "cnc_3",
    description: "Shoot - cape -vine",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-cnc_3.wav",
    winner: "cnc_3_d1e71141-1577-41a9-9b58-017bc5293a32.wav",
    original: "original_wavs/CNC_3.wav"
  },
  cnc_4: {
    tag: "cnc",
    label: "cnc_4",
    description: "Chase – roof – thin",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-cnc_4.wav",
    winner: "cnc_4_a95cce64-a131-4660-986e-1ea27d5555fe.wav",
    original: "original_wavs/CNC_4.wav"
  },
  cnc_5: {
    tag: "cnc",
    label: "cnc_5",
    description: "Path – phone – chill",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-cnc_5.wav",
    winner: "cnc_5_64364feb-d870-42fb-a5f8-11261f4ec48b.wav",
    original: "original_wavs/CNC_5.wav"
  },
  cnc_6: {
    tag: "cnc",
    label: "cnc_6",
    description: "Sung – lathe – tire",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-cnc_6.wav",
    winner: "cnc_6_10324952-f3ef-45bd-8bce-07982a83ecd1.wav",
    original: "original_wavs/CNC_6.wav"
  },
  // Speech in noise
  speech_in_noise_1: {
    tag: "speech_in_noise",
    label: "speech_in_noise_1",
    description: "She was talented in creating difficult situations.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-speech_in_noise_1.wav",
    winner: "speech_in_noise_1_cd950e22-99f9-4f21-bdd7-fcd8f2e43ebe.wav",
    original: "original_wavs/SIN_1.wav"
  },
  speech_in_noise_2: {
    tag: "speech_in_noise",
    label: "speech_in_noise_2",
    description: "A snowy cabin is very romantic.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-speech_in_noise_2.wav",
    winner: "speech_in_noise_2_543f77e1-7871-4115-8bf7-068aa3734bdd.wav",
    original: "original_wavs/SIN_2.wav"
  },
  speech_in_noise_3: {
    tag: "speech_in_noise",
    label: "speech_in_noise_3",
    description: "Do you have plans for the weekend?",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-speech_in_noise_3.wav",
    winner: "speech_in_noise_3_e2dd022c-8715-4b75-a102-32e4330c203e.wav",
    original: "original_wavs/SIN_3.wav"
  },
  speech_in_noise_4: {
    tag: "speech_in_noise",
    label: "speech_in_noise_4",
    description: "You are a wonderful and attractive person.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-speech_in_noise_4.wav",
    winner: "speech_in_noise_4_e0ac4e35-4f55-4cbc-9073-c58f568faa98.wav",
    original: "original_wavs/SIN_4.wav"
  },
  speech_in_noise_5: {
    tag: "speech_in_noise",
    label: "speech_in_noise_5",
    description: "There is no singing and dancing in the movies.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-speech_in_noise_5.wav",
    winner: "speech_in_noise_5_a1f55027-3420-42c9-bae3-27bdce12c9b7.wav",
    original: "original_wavs/SIN_5.wav"
  },
  speech_in_noise_6: {
    tag: "speech_in_noise",
    label: "speech_in_noise_6",
    description: "I will devote my life to earning money.",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-speech_in_noise_6.wav",
    winner: "speech_in_noise_6_01111a7c-671d-4169-9967-aae7a99621d3.wav",
    original: "original_wavs/SIN_6.wav"
  },
  // Music
  music_1: {
    tag: "music",
    label: "music_1",
    description: "David Bowie – Moonage Daydream",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-music_1.wav",
    winner: "music_1_70ad5acf-9a16-406a-9f18-eadf2025730f.wav",
    original: "original_wavs/Music_1.wav"
  },
  music_2: {
    tag: "music",
    label: "music_2",
    description: "Tchaikovsky – Swan Lake",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-music_2.wav",
    winner: "music_2_c6a89479-1acd-4cee-8639-b68cf972adda.wav",
    original: "original_wavs/Music_2.wav"
  },
  music_3: {
    tag: "music",
    label: "music_3",
    description: "The Beatles – Happiness is a Warm Gun",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-music_3.wav",
    winner: "music_3_26f1e4b8-ee74-4eb1-af8f-95a84bb35199.wav",
    original: "original_wavs/Music_3.wav"
  },
  music_4: {
    tag: "music",
    label: "music_4",
    description: "Maroon 5 - Misery",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-music_4.wav",
    winner: "music_4_0c8460f4-7bce-4359-9129-d39abae3d336.wav",
    original: "original_wavs/Music_4.wav"
  },
  music_5: {
    tag: "music",
    label: "music_5",
    description: "Muse - Madness",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-music_5.wav",
    winner: "music_5_5fbc6bf2-af5f-4a23-a068-6956fd32d741.wav",
    original: "original_wavs/Music_5.wav"
  },
  music_6: {
    tag: "music",
    label: "music_6",
    description: "John Philip Sousa - Stars and Stripes",
    gold_standard: "round2-ab-gold-standard/ab-gold-standard-music_6.wav",
    winner: "music_6_a33fccf1-d8f4-45c3-97d2-c692a28becb3.wav",
    original: "original_wavs/Music_6.wav"
  },
};

export default {
  ...round1entries,
};
